/**
 * A set code as people should read it: upper case whatever the source used ("ven", "sv08"), and
 * nothing at all for a raw upstream slug ("justtcg-radiance-riftbound-…"), which means no real
 * code has been assigned yet. Display only: filters and lookups keep using the stored value.
 */
export function formatSetCode(setCode: string | null | undefined): string {
  const code = String(setCode ?? '').trim()
  if (!code || /^(justtcg|scryfall)-/i.test(code)) return ''
  return code.toUpperCase()
}
